import React from 'react'
import { Toast } from 'antd-mobile'
import { Modal } from 'components'
import _ from 'lodash'
import currencyFormatter from 'currency-formatter'
import * as ENUMS from './enum'
import UAParser from 'ua-parser-js'
import messages from './messages'
import intl from './intl'
import moment from 'moment'
moment.locale(getCurrentLanguage())

export function checkFormError(errors) {
  // check passed form errors, if this is no error, return true, else show the first error
  if (!errors) {
    return true
  }
  const msg = _.chain(errors).values().map('errors').flatten().first().get('message').value()
  setTimeout(() => {
    Toast.info(msg, 1.5)
  }, 50)
  return false
}

export function getUUID(length = 32) {
  return [...Array(length)]
    .map((i) => (~~(Math.random() * 36)).toString(36))
    .join('')
}

export function handleDate(date) {
  return date ? moment(date).format('DD/MM/YYYY HH:mm') : ''
}

export function handleAmount({ amount = 0, currency, direction = '2' }) {
  if (direction === '-') {
    direction = 0
  }
  if (direction === '+') {
    direction = 1
  }
  const directions = ['-', '+', '']
  var precision = 2
  if (currency === 'GP') {
    var showGPIcon = true
    currency = ''
    precision = 0
  }
  const result = currencyFormatter.format(amount, {
    symbol: currency,
    precision: precision,
    format: currency
      ? `%s ${directions[direction]}%v`
      : `${directions[direction]}%v`, // %s is the symbol and %v is the value
  })
  return (
    <React.Fragment>
      {showGPIcon && <span className='iconfont iconGreenPoints' />}
      {result}
    </React.Fragment>
  )
}

export function getCurrentLanguage(params) {
  // 从User-Agent获取语言，兼容IOS无法设置webview语言
  const data = PayByInfo()
  const supportLanguages = ['en', 'ar']
  const currentLanguage = data.lang || window.navigator.language.split(/[-_]/)[0]
  return supportLanguages.indexOf(currentLanguage) > -1 ? currentLanguage : 'en'
}

export function setHtmlLangAndDir(language) {
  document.documentElement.setAttribute('lang', language)
  if (language === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl')
  } else {
    document.documentElement.removeAttribute('dir')
  }
}

export function isPayBy() {
  // 判断是否在PayBy环境下
  return navigator.userAgent.toLowerCase().indexOf('payby') !== -1
}

export function isToTok() {
  // 判断是否在ToTok webview环境下
  return !isPayBy() && navigator.userAgent.toLowerCase().indexOf('totok') !== -1
}

export function isBOTIM() {
  // 判断是否在BOTIM webview环境下
  return !isPayBy() && navigator.userAgent.toLowerCase().indexOf('botim') !== -1
}

export function inIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export function openUri(uri) {
  console.log('openUri:', uri)
  const OSName = new UAParser().getOS().name
  switch (OSName) {
    case 'iOS':
    case 'Android':
      if (inIframe()) {
        // 父页面注册message方法，拿到deeplink的地址后做跳转
        // window.addEventListener('message', function(e) {
        //   if (e.data.message === 'PayBy_Cashier_Link') {
        //     window.location.href = e.data.uri
        //   }
        // })
        const message = {
          message: 'PayBy_Cashier_Link',
          uri: uri,
        }
        window.parent.postMessage(message, '*')
      } else {
        window.open(uri, '_blank')
      }
      break
    // case 'Android':
    //   var iframe = document.createElement('iframe')
    //   iframe.src = uri
    //   iframe.style.display = 'none'
    //   document.body.appendChild(iframe)
    //   window.setTimeout(function () {
    //     document.body.removeChild(iframe)
    //   }, 1000)
    //   break
    default:
      Toast.info(intl.formatMessage(messages.networkError))
      break
  }
}

export function openNative(url, needCallBack, callback) {
  // h5打开native原生功能
  console.log(url, needCallBack)
  try {
    window.ToPayJSBridge.invoke(
      'openNative',
      { router: url, needCallback: needCallBack || false },
      function(data) {
        const res = JSON.parse(data)
        console.log(res)
        typeof callback === 'function' && callback(res)
      }
    )
  } catch (error) {
    console.log(error)
  }
}

export function handleIdentifyHint(identifyHint) {
  console.info('identifyHint:', identifyHint)
  if (!identifyHint || !_.isArray(identifyHint.identifyMethods)) {
    return {}
  }
  const currentIdentifyHint = identifyHint.identifyMethods.shift()
  console.info('currentIdentifyHint', currentIdentifyHint)
  return {
    ...currentIdentifyHint,
  }
}

export function showBuyerNotMatchAlert(data) {
  const returnUrl = sessionStorage.getItem('returnUrl')
  Modal.alert(
    intl.formatMessage(messages.showBuyerNotMatchAlertTitle),
    <div className='text-left'>{data.head.msg}</div>,
    [
      {
        text: (
          <span className='gray'>
            {intl.formatMessage(messages.showBuyerNotMatchAlertBtnBack)}
          </span>
        ),
        onPress: () => (window.location.href = returnUrl),
      },
      {
        text: (
          <span className='green'>
            {intl.formatMessage(messages.showBuyerNotMatchAlertBtnRemain)}
          </span>
        ),
        onPress: () => window.history.back(),
      },
    ]
  )
}

export const numberNormalize = (len, decimal = true) => (value, prevValue) => {
  try {
    if (value < 0) {
      return prevValue
    }
    if (value?.toString()?.match(/^-{0,1}(\d+)$/)) {
      if (value.length > len) {
        return prevValue
      }
      return value
    // valid integer (positive or negative)
    } else if (value?.match(/^\d+\.\d+$/) && decimal) {
    // valid float
      const decimal = value.split('.')[1]
      if (decimal.length > 2) {
        return prevValue
      }
      return value
    } else if (value?.match(/\./g)?.length === 1 && value?.substr(-1) === '.') {
      if (decimal) {
        return value
      }
      return prevValue
    // valid empty string
    } else if (value?.match(/^$/)) {
      return value
    } else if (value?.length > len) {
      return prevValue
    } else {
      return prevValue
    // not valid number
    }
  } catch (e) {
    console.log(e)
  }
}

export function PayByInfo() {
  // PayBy/${PayBySDKVersion} (${hostAppName}, ${hostAppVersion}, ${IP}, ${mobileBrand})
  // 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_4_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 PayBy/1.5.1 (payby, 1.3.0, 192.168.1.4, iPhone 6)'
  const userAgent = navigator.userAgent
  if (userAgent.toLowerCase().indexOf('payby') === -1) {
    return {}
  }
  try {
    const PayBySDKVersion = userAgent.match(/PayBy\/([0-9.]+)/)[1]
    const infos = userAgent.match(/PayBy\/[0-9. ]+\(([^\\)]+)/)[1].split(',')
    return {
      PayBySDKVersion,
      hostAppName: infos[0].trim(' '),
      hostAppVersion: infos[1].trim(' '),
      IP: infos[2].trim(' '),
      mobileBrand: infos[3].trim(' '),
      lang: infos[4] && infos[4].trim(' '),
    }
  } catch (error) {
    return {}
  }
}

export function downloadApp(platform) {
  const OSName = new UAParser().getOS().name
  console.log(OSName)
  switch (OSName) {
    case 'Android':
      openUri(ENUMS.downloadAppUris.Android[platform])
      break
    case 'iOS':
    case 'Mac OS':
      openUri(ENUMS.downloadAppUris.iOS[platform])
      break
    default:
      Toast.info(intl.formatMessage(messages['app.error.downloadNotSupport']))
      break
  }
}

export function redirectToErrorPage({ code, msg, traceCode }) {
  traceCode = traceCode ? `[${traceCode}]` : ''
  window.location.replace(`/error?code=${code}&msg=${msg}${traceCode}`)
}

export { ENUMS, intl }
export { recordEvent } from './JSBridge'
